<nscf-cta-button class="cta-button" [ctaUrl]="element?.ctaUrl" [text]="element?.ctaLabel"></nscf-cta-button>
@if (element?.ctaConditions) {
  <p class="text-xs">{{ element.ctaConditions }}</p>
}
